import * as yup from 'yup'
import { IntlShape, defineMessages } from 'react-intl'

import { IVisualizationSettingsForm } from './types'
import { GTCompanyV2Vertical } from 'gql/types.generated'

const messages = defineMessages({
  modalitiesRequired: {
    id: 'settings.form.modalities.required',
    defaultMessage: 'At least one confirmation modality is required'
  }
})

export const visualizationSettingsSchema = (intl: IntlShape): yup.SchemaOf<IVisualizationSettingsForm> => {
  return yup.object().shape({
    crewUsers: yup.array().optional(),
    confirmationModalities: (yup.array() as yup.SchemaOf<IVisualizationSettingsForm['confirmationModalities']>).test(
      'modalitiesRequired',
      intl.formatMessage(messages.modalitiesRequired),
      function (confirmationModalities) {
        if (this.parent.vertical === GTCompanyV2Vertical.Rental) {
          return true
        }
        const hasAtLeastOneModalityWithSalesChannel = confirmationModalities?.some(
          (modality) => modality.salesChannels && modality.salesChannels.length > 0
        )
        return Boolean(hasAtLeastOneModalityWithSalesChannel)
      }
    ),
    showSeatsMap: yup.boolean().optional(),
    isPetFriendly: yup.boolean().required()
  })
}
